<template>
  <div class="hello-world">
    {{ message }}
  </div>
</template>

<script setup lang="ts">
const props = defineProps<{ message: string }>()
</script>

<style scoped>
.hello-world {
  padding: 1rem;
  border: 1px solid #333;
  border-radius: 4px;
}
</style>
